module.exports = __webpack_public_path__ + "img/知识体系.d9f16e19.svg";